import { ReactComponent as Banner } from "../assets/graphics/michelle-illustration-banner.svg";
import "../styles/components/footer.scss";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <p>© Michelle Heppner Photography 2025</p>
        <p>
          <a href="mailto:michelleelizabethheppner@gmail.com">
            michelleelizabethheppner@gmail.com
          </a>
        </p>
      </div>
      <Banner className="banner" />
    </footer>
  );
}

export default Footer;
